const mergeStops = (currentStops = [], newStops = [], { shouldPrepend = false } = {}) => {
  if (shouldPrepend) {
    return [...newStops, ...currentStops];
  }

  return [...currentStops, ...newStops];
};

export default mergeStops;
